import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  children: [],
  currentChild: null,
  loading: false,
  error: null,
  filteredChildren: [],
}

const childrenSlice = createSlice({
  name: "children",
  initialState,
  reducers: {
    // Pour mettre à jour toute la liste des enfants
    setChildrenState: (state, { payload }) => {
      state.children = payload
    },
    // Pour modifier un enfant spécifique
    setChildState: (state, { payload }) => {
      state.currentChild = payload
    },
    // Pour ajouter/mettre à jour un enfant
    upsertChildState: (state, { payload }) => {
      // Vérification de sécurité
      if (!payload || !payload.id) {
        console.error("Payload invalide dans upsertChildState:", payload);
        return;
      }
    
      const index = state.children.findIndex((c) => c.id === payload.id);
      if (index >= 0) {
        state.children[index] = payload;
      } else {
        state.children.push(payload);
      }
    },
    // Pour gérer le chargement
    setLoading: (state, { payload }) => {
      state.loading = payload
    },
    // Pour gérer les erreurs
    setError: (state, { payload }) => {
      state.error = payload
    },
    // Pour filtrer les enfants par présence
    setFilteredChildrenState: (state, { payload }) => {
      state.filteredChildren = payload
    },
    // Pour supprimer un enfant
    removeChildState: (state, { payload }) => {
      state.children = state.children.filter((c) => c.id !== payload)
    },

    updateChildPresence: (state, { payload }) => {
      const { childId, presence, date } = payload;
      
      // 1. Mettre à jour la liste filtrée
      if (state.filteredChildren.length > 0) {
        state.filteredChildren = state.filteredChildren.filter(child => {
          // Si l'enfant correspond et que le statut ne correspond plus au filtre actuel
          return child.id !== childId || child.currentPresence === presence;
        });
      }
      
      // 2. Mettre à jour la liste complète
      state.children = state.children.map(child => {
        if (child.id === childId) {
          return { 
            ...child, 
            currentPresence: presence,
            lastPresenceUpdate: date
          };
        }
        return child;
      });
    },
  },
});
// Export des actions
export const {
  setChildrenState,
  setChildState,
  upsertChildState,
  setLoading,
  setError,
  setFilteredChildrenState,
  removeChildState,
  updateChildPresence,
} = childrenSlice.actions

export default childrenSlice.reducer

